module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-2-2015.svg?v=e214d53e";